module.exports = __webpack_public_path__ + "/build/web/images/hero-about@2x.000dd78d8309e2083578240accea7b54.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-about@2x.jpg
// module id = 134
// module chunks = 13